import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/templebet/images/logo/logo-mobile.png';

export default function Index() {
  return <Image src={logo} maxW="157px" position="relative" top="1.5" />;
}
